import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getWithdrawalRequest: ["withdrawal_id"],
  getWithdrawalSuccess: ["listFileWithdrawal"],
  getWithdrawalFailure: null,
  clearGetWithdrawalData: null,
});

export const GetWithdrawalTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  withdrawal_id: null,
  fetching: null,
  success: null,
  listFileWithdrawal: null,
  error: null,
});

export const GetWithdrawalSelectors = {
  getData: (state: any) => state.getWithdrawal.data,
  isFetching: (state: any) => state.getWithdrawal.fetching,
  isSuccess: (state: any) => state.getWithdrawal.success,
  hasError: (state: any) => state.getWithdrawal.error,
};

export const request = (state: any, { withdrawal_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    withdrawal_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listFileWithdrawal } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listFileWithdrawal,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    listFileWithdrawal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const clearGetWithdrawalData = (state: any) => {
  const updateData = {
    listFileWithdrawal: null,
    withdrawal_id: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_WITHDRAWAL_REQUEST]: request,
  [Types.GET_WITHDRAWAL_SUCCESS]: success,
  [Types.GET_WITHDRAWAL_FAILURE]: failure,
  [Types.CLEAR_GET_WITHDRAWAL_DATA]: clearGetWithdrawalData,
});
